import React, { useState, useEffect, useMemo, useRef } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import CustomPagination from '../../components/company_panel/common/custompagination'
import { capitalizeFirstLetter, checkPermission, formateDate, getBrandId, getOutletBusinessDate, getOutletId, isOnline, removeHyphens, getExcelColumnWidths } from '../../helpers/commonFunctions';
import { GetBrandOutletsList } from '../../services/company_panel/outletService';
import Sorting from '../../components/company_panel/common/sorting';
import Loader from '../../components/company_panel/common/loader'
import StatusFilter from '../../components/company_panel/common/statusFilter'
import { LOADER_TIME, showFilterlist } from '../../utils/Constants'
import CustomRangepicker from '../../components/company_panel/common/rangepicker'
import $ from "jquery";
import { getCompany } from '../../helpers/commonFunctions';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import notFound from '../../assets/company/img/no-record-found.png'
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { ListTransaction } from '../../services/company_panel/transcation.services';
import GlobalLoader from '../../components/company_panel/common/globalLoader';
import { usePersistedListState } from '../../hooks/usePersistedListState';


const TransactionList = () => {

    const navigate = useNavigate()
    const location = useLocation()
    const params = useParams()
    // persisted filters (page lives in the route) — restored on return from view
    const { saved, save, clear } = usePersistedListState('transactions');
    const [list, setList] = useState([])
    const [statsUpdate, setStatusUpdate] = useState("false")
    const [dataLength, setDataLength] = useState()
    const [itemPerPage, setItemPerPage] = useState(saved?.itemPerPage || 10)
    const [sorting, setSorting] = useState(saved?.sorting || {});
    const [defaultSorting, setDefaultSorting] = useState(true);
    const [page, setPage] = useState(Number(params?.id) || 1);
    const [loader, setLoader] = useState(true)
    const [globalLoader, setGlobalLoader] = useState(false);
    const [search, setSearch] = useState(saved?.search || {})
    const [globalSearch, setGlobalSearch] = useState(saved?.globalSearch || "")
    const [resetdate, setResetDate] = useState(false);
    const [isBrandChanged, setIsBrandChanged] = useState(false);
    const [isOutletChanged, setIsOutletChanged] = useState(false);

    const businessDate =  getOutletBusinessDate();
    const start_date = new Date(businessDate.setHours(0,0,0,0));
    const end_date = new Date(businessDate.setHours(23,59,59,999));
    // console.log(businessDate);
    // if we're returning with a persisted date filter, show that range in the picker
    // instead of the default business date (records already restore from saved.search)
    const [defaultDateFilter, setDefaultDateFilter] = useState(
        saved?.search?.created
            ? [new Date(saved.search.created.start), new Date(saved.search.created.end)]
            : [start_date, end_date]
    );
    const defaultDateFilterRef = useRef({
        start_date,
        end_date
    });

    useMemo(() => {
        document.addEventListener('brand-changed', function () {
            setIsBrandChanged(!isBrandChanged);
        });
        document.addEventListener('outlet-changed', function () {
            setSearch({});
                                        
            const businessDate =  getOutletBusinessDate();
            const start_date = new Date(businessDate.setHours(0,0,0,0));
            const end_date = new Date(businessDate.setHours(23,59,59,999));
            setDefaultDateFilter([
                start_date,
                end_date
            ])
            defaultDateFilterRef.current = {
                start_date,
                end_date
            }
            
            setIsOutletChanged(!isOutletChanged);
        });
    });

    useEffect(() => {
        if (search) {
            setLoader(true)
            setTimeout(() => {
                const formData = new FormData()

                let modifiedSearchFilter= search;
                if(!search || !search.created){
                    modifiedSearchFilter = {
                        ...(search ? search : {}),
                        created: {
                            start: defaultDateFilterRef.current?.start_date.toISOString(),
                            end: defaultDateFilterRef.current?.end_date.toISOString()
                        }
                    }
                }
                formData.append("search", JSON.stringify(modifiedSearchFilter));

                formData.append("page", page)
                formData.append("per_page", itemPerPage)
                formData.append("sort", JSON.stringify(sorting))
                formData.append("global_search", globalSearch)
                formData.append('outlet_id', getOutletId());
                ListTransaction(formData).then(data => {
                    setDataLength(data.data.response.count);
                    setList(data && data.data && data.data.response ? data.data.response.rows : [])
                    setLoader(false);
                }).catch(error => {
                    console.log("error ====> ", error);
                    setLoader(false);
                })
            }, 500);
        }
    }, [location, statsUpdate, sorting, search, globalSearch, isBrandChanged, isOutletChanged, defaultDateFilter])

    // persist filters on every change (page lives in the route, not the store)
    useEffect(() => {
        save({ itemPerPage, sorting, search, globalSearch });
    }, [itemPerPage, sorting, search, globalSearch])

    // On company panel reload, fetch the outlet's current business date once (it can change from other panels)
    useEffect(() => {
        if (!isOnline()) return;
        GetBrandOutletsList({ brand_ids: JSON.stringify([getBrandId()]) }).then(data => {
            const outlets = data?.data?.response || [];
            const currentOutlet = outlets.find(o => Number(o.id) === Number(getOutletId()));
            if (currentOutlet?.business_date) {
                localStorage.setItem('outlet_business_date', currentOutlet.business_date);
                const start_date = new Date(new Date(currentOutlet.business_date).setHours(0, 0, 0, 0));
                const end_date = new Date(new Date(currentOutlet.business_date).setHours(23, 59, 59, 999));
                defaultDateFilterRef.current = { start_date, end_date };
                // don't clobber the picker if we restored a persisted date filter
                if (!saved?.search?.created) {
                    setDefaultDateFilter([start_date, end_date]);
                }
            }
        }).catch(error => {
            console.log("business date error ====> ", error);
        });
    }, []);


    const resetFilter = (e) => {
        e.preventDefault()
        setGlobalSearch("")
        setSearch({})
        setResetDate(!resetdate)
        setDefaultDateFilter([defaultDateFilterRef.current.start_date, defaultDateFilterRef.current.end_date])
        clear()
    }

    const viewFunction = (row) => {
        navigate(`/company/transaction/transaction/view/${row}?pageno=${page}`)
    }

    const handleSort = (e, column) => {
        setDefaultSorting(false);
        let sort = { order: 0, column: column };
        if (e.target.classList.contains("assc")) {
            sort.order = -1;
        } else {
            sort.order = 1;
        }
        setSorting(sort);
    }

    const prepareSearch = (key, value) => {
        let sr = { ...search };
        if (String(value).length > 0) {
            sr[key] = value;
        } else {
            delete sr[key];
        }
        setSearch(sr);
    }

    const headerMapping = {
        "transaction_id": "Transaction ID",
        "customer_name": "Customer Name",
        "customer_number": "Customer Number",
        "order_id": "Order ID",
        "order_mode" : "Order Mode",
        "aggregator_name" : "Aggregator Name",
        "order_by" : "Order By",
        "amount": "Amount",
        "payment_status": "Status",
        "payment_method": "Payment Method",
        "created_at" : "Created Date",
        "business_date": "Business Date"
    };

    const handleExport = () => {
        setGlobalLoader(true);
        const formData = new FormData()
        formData.append("page", 1)
        formData.append("per_page", dataLength)
        formData.append("sort", JSON.stringify(sorting))
        formData.append("search", JSON.stringify(search))
        formData.append("global_search", globalSearch)
        formData.append('outlet_id', getOutletId());
        ListTransaction(formData).then(data => {
            const listData = data && data.data && data.data.response ? data.data.response.rows : [];
            const printData = listData.map((item) => {
                const transformedItem = {};
                // Extract fields from nested objects
                const transactionID = item?.transaction_id || 'N/A';
                const customerName = item?.customer?.customer_name || 'N/A';
                const customerNumber = item?.customer?.customer_number || 'N/A';
                const orderID = item?.customer_order?.id || 'N/A';
                const orderMode = item?.customer_order?.order_mode_configuration?.name || 'N/A';
                const aggregatorName = item?.customer_order?.aggregators_configuration?.name || 'N/A';
                const orderBy = item?.customer_order?.order_source == 'online' ? 'Online' : (item?.customer_order?.user?.first_name + " " + item?.customer_order?.user?.last_name  || 'N/A');
                const amount = item?.amount + " " + "SAR" || 'N/A';
                const paymentMethod = item?.payment_method || 'N/A';
                // const paymentStatus = item?.payment_status || 'N/A';
                const paymentStatus = item?.payment_status
                    ?
                        item?.payment_status != 'refunded'
                        ?   capitalizeFirstLetter(item?.payment_status)
                        :   item?.refundReason?.type_of_refund == 'full' ? 'Refunded' : 'Partial Refunded'
                    : "N/A"
                const createdAt = new Date(item.created_at).toLocaleString('en-GB', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: true,
                }).replace(',', '');

                // Map fields according to headerMapping
                for (const key in headerMapping) {
                    if (headerMapping.hasOwnProperty(key)) {
                        const newKey = headerMapping[key];
                        switch (key) {
                            case "transaction_id":
                                transformedItem[newKey] = transactionID;
                                break;
                            case "customer_name":
                                transformedItem[newKey] = capitalizeFirstLetter(customerName);
                                break;
                            case "customer_number":
                                transformedItem[newKey] = capitalizeFirstLetter(customerNumber);
                                break;
                            case "order_id":
                                transformedItem[newKey] = (orderID);
                                break;
                            case "order_mode":
                                transformedItem[newKey] = capitalizeFirstLetter(orderMode);
                                break;
                            case "aggregator_name":
                                transformedItem[newKey] = capitalizeFirstLetter(aggregatorName);
                                break;
                            case "order_by":
                                transformedItem[newKey] = capitalizeFirstLetter(orderBy);
                                break;
                            case "amount":
                                transformedItem[newKey] = amount;
                                break;
                            case "payment_method":
                                transformedItem[newKey] = capitalizeFirstLetter(paymentMethod);
                                break;
                            case "payment_status":
                                transformedItem[newKey] = capitalizeFirstLetter(paymentStatus);
                                break;
                            case "created_at":
                                transformedItem[newKey] = createdAt;
                                break;
                             case "business_date":
                                transformedItem[newKey] = formateDate(item.business_date);
                                break;
                            default:
                                // Handle any unexpected keys
                                console.warn(`Unexpected key in headerMapping: ${key}`);
                                transformedItem[newKey] = 'N/A';
                                break;
                        }
                    }
                }
                return transformedItem;
            });

            const ws = XLSX.utils.json_to_sheet(printData, { header: Object.values(headerMapping) });
            ws['!cols'] = getExcelColumnWidths(printData, Object.values(headerMapping));
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
            saveAs(blob, 'Transaction.xlsx');
            // setTimeout(() => {
            //     setLoader(false);
            // }, LOADER_TIME);
            setGlobalLoader(false);
        }).catch(error => {
            // setTimeout(() => {
            //     setLoader(false);
            // }, LOADER_TIME);
            console.log("error ====> ", error);
            setGlobalLoader(false);
        })
    };


    // const printData = (row, index) => {
    //     const printContent = `
    //         <div style="max-width: 600px; margin: auto; padding: 20px; border: 1px solid #ccc; border-radius: 5px;">
    //             <h1 style="text-align: left; color: #333;">${row.customer_order.order_id || 'N/A'}</h1>
    //             <h2 style="text-align: center; color: #333;">Invoice</h2>
    //             <hr style="border: 1px solid #ccc;">
    //             <div style="margin-bottom: 20px;">
    //                 <h3 style="color: #666;">Transaction Details</h3>
    //                 <p><strong>Transaction ID:</strong> ${row.transaction_id || 'N/A'}</p>
    //                 <p><strong>Customer Name:</strong> ${row.customer?.customer_name ? capitalizeFirstLetter(row.customer.customer_name) : 'N/A'}</p>
    //                 <p><strong>Customer Number:</strong> ${row.customer?.customer_number || 'N/A'}</p>
    //                 <p><strong>Order ID:</strong> ${row.customer_order.order_id || 'N/A'}</p>
    //                 <p><strong>Amount:</strong> ${row.amount ? row.amount + " SAR" : 'N/A'}</p>
    //                 <p><strong>Status:</strong> ${row.payment_status ? capitalizeFirstLetter(row.payment_status) : 'N/A'}</p>
    //                 <p><strong>Payment Method:</strong> ${row.payment_method ? capitalizeFirstLetter(row.payment_method) : 'N/A'}</p>
    //             </div>
    //             <hr style="border: 1px solid #ccc;">
    //             <p style="text-align: center; font-style: italic;">Thank you for your business!</p>
    //         </div>
    //     `;
    
    //     const printWindow = window.open('', '_blank');
    //     printWindow.document.write(`
    //         <html>
    //             <head>
    //                 <title>Invoice Print</title>
    //                 <style>
    //                     body { font-family: Arial, sans-serif; }
    //                     h2 { margin-bottom: 10px; }
    //                     h3 { margin: 10px 0; }
    //                     p { line-height: 1.5; margin: 5px 0; }
    //                     hr { margin: 20px 0; }
    //                 </style>
    //             </head>
    //             <body>
    //                 ${printContent}
    //             </body>
    //         </html>
    //     `);
    //     printWindow.document.close();
    //     printWindow.print();
    //     printWindow.close();
    // };

    const printData = (row, index) => {
        const printContent = `
            <div style="max-width: 600px; margin: auto; padding: 20px; border: 1px solid #ccc; border-radius: 5px;">
                <h1 style="text-align: left; color: #333;">${row.customer_order.order_id || 'N/A'}</h1>
                <h2 style="text-align: center; color: #333;">Invoice</h2>
                <hr style="border: 1px solid #ccc;">
                <div style="margin-bottom: 20px;">
                    <h3 style="color: #666;">Transaction Details</h3>
                    <p><strong>Transaction ID:</strong> ${row.transaction_id || 'N/A'}</p>
                    <p><strong>Customer Name:</strong> ${row.customer?.customer_name ? capitalizeFirstLetter(row.customer.customer_name) : 'N/A'}</p>
                    <p><strong>Customer Number:</strong> ${row.customer?.customer_number || 'N/A'}</p>
                    <p><strong>Order ID:</strong> ${row.customer_order.order_id || 'N/A'}</p>
                    <p><strong>Amount:</strong> ${row.amount ? row.amount + " SAR" : 'N/A'}</p>
                    <p><strong>Status:</strong> ${row.payment_status ? capitalizeFirstLetter(row.payment_status) : 'N/A'}</p>
                    <p><strong>Payment Method:</strong> ${row.payment_method ? capitalizeFirstLetter(row.payment_method) : 'N/A'}</p>
                </div>
                <hr style="border: 1px solid #ccc;">
                <p style="text-align: center; font-style: italic;">Thank you for your business!</p>
            </div>
        `;
    
        const iframe = document.createElement('iframe');
        iframe.style.position = 'absolute';
        iframe.style.width = '0';
        iframe.style.height = '0';
        iframe.style.border = 'none';
        document.body.appendChild(iframe);
    
        const doc = iframe.contentWindow.document;
        doc.open();
        doc.write(`
            <html>
                <head>
                    <title>Invoice Print</title>
                    <style>
                        body { font-family: Arial, sans-serif; }
                        h2 { margin-bottom: 10px; }
                        h3 { margin: 10px 0; }
                        p { line-height: 1.5; margin: 5px 0; }
                        hr { margin: 20px 0; }
                    </style>
                </head>
                <body>
                    ${printContent}
                </body>
            </html>
        `);
        doc.close();
    
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        document.body.removeChild(iframe);
    };
    
    

    return (
        <>
            {globalLoader && <GlobalLoader/>}
            <div className="animation_fade">
                <div className='page-header d-flex align-items-center'>
                    <div className='page-header-left'>
                        <h4>Transaction</h4>
                    </div>
                    <div className='page-header-right ms-auto'>
                        <button onClick={handleExport} disabled={dataLength === 0} className="btn btn-primary ms-2">Export Transaction</button>
                    </div>
                </div>
                <div className="card custom-card overflow-hidden">
                    <div className='gap-20'>
                        <div className='filter-header d-flex justify-content-between align-items-center'>
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="form-group mb-0 rangepicker_container">
                                    <input type="search" className="form-control" value={globalSearch} placeholder="Search" onChange={(e) => { setGlobalSearch(e.target.value) }} />
                                </div>
                            </div>
                            <div className='d-flex gap-3 align-items-center'>
                                <div className="date-input">
                                    <CustomRangepicker defaultDateFilter={defaultDateFilter} GetDateRange={(e) => { prepareSearch("created", e) }} resetdate={resetdate} />
                                </div>
                                <button type="reset" value='Reset' onClick={resetFilter} className="btn btn-primary mr-2">Reset Filter</button>
                            </div>
                        </div>
                    </div>
                    <div className="tabler-wrap">
                        <div className="table-responsive">
                            <table className="table table-custom">
                                <thead>
                                    <tr>
                                        <th width="8%">
                                            <div className='sorting_column'>
                                                <span>Transaction ID</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="id" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <span>Customer Name</span>
                                        </th>
                                        <th width="10%">
                                            <span>Customer Number</span>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Order ID</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="order_id" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <span>Order Mode</span>
                                        </th>
                                        <th width="10%">
                                            <span>Aggregator Name</span>
                                        </th>
                                        <th width="10%">
                                            <span>Ordered By</span>
                                        </th>
                                        <th width="10%">
                                            <div className='sorting_column'>
                                                <span>Amount</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="amount" />
                                            </div>
                                        </th>
                                        <th width="10%">
                                            <span>Payment Method</span>
                                        </th>
                                        <th width="10%">
                                            <span>Payment Status</span>
                                        </th>
                                        <th className="created_head" width="15%">
                                            <div className='sorting_column'>
                                                <span>Created At</span>
                                                <Sorting sort={sorting} handleSort={handleSort} defaultSorting={defaultSorting} column="created_at" />
                                            </div>
                                        </th>
                                        <th className="created_head" width="20%">
                                            <div className='sorting_column'>
                                                <span>Business Date</span>
                                                <Sorting sort={sorting} handleSort={handleSort} column="business_date" />
                                            </div>
                                        </th>
                                        <th className='action_head text-end' width="8%" style={{ paddingLeft: "3.5rem" }}>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {loader ?
                                        <tr>
                                            <td colSpan={12}>
                                                <Loader />
                                            </td>
                                        </tr> : <>
                                            {list.length ? list.map((row, index) => (
                                                <tr>
                                                    <td>#{row?.transaction_id ? row?.transaction_id : 'N/A'}</td>
                                                    <td>{row?.customer?.customer_name ? capitalizeFirstLetter((row?.customer_order?.customer_name)) : 'N/A'}</td>
                                                    <td>{row?.customer?.customer_number ? row?.customer?.customer_number : '-'}</td>
                                                    <td>#{row?.customer_order?.id ? row?.customer_order?.id : 'N/A'}</td>
                                                    <td>{row?.customer_order?.order_mode_configuration?.name ? capitalizeFirstLetter(row?.customer_order?.order_mode_configuration?.name) : 'N/A'}</td>
                                                    <td>{row?.customer_order?.aggregators_configuration?.name ? capitalizeFirstLetter(row?.customer_order?.aggregators_configuration?.name) : 'N/A'}</td>
                                                    <td>{row?.customer_order?.user ? `${capitalizeFirstLetter(row?.customer_order?.user?.first_name)} ${capitalizeFirstLetter(row?.customer_order?.user?.last_name)}` : 'N/A'}</td>
                                                    <td>{row?.amount ? row?.amount + " " + "SAR" : 'N/A'}</td>
                                                    <td>{row?.tender_name ? capitalizeFirstLetter(row?.tender_name) : 'N/A'}</td>
                                                    <td>
                                                        {/* {
                                                            row?.payment_status ? 
                                                                row?.payment_status == 'refunded' ?
                                                                row?.amount == row?.refunded_amount ? 'Refunded' : 'Partial Refunded' 
                                                                : capitalizeFirstLetter(row?.payment_status)
                                                            : 'N/A'
                                                        } */}
                                                        {
                                                            row?.payment_status
                                                            ?
                                                                row?.payment_status != 'refunded'
                                                                ?   capitalizeFirstLetter(row?.payment_status)
                                                                :   row?.refundReason?.type_of_refund == 'full' ? 'Refunded' : 'Partial Refunded'
                                                            : "N/A"
                                                        }
                                                    </td>
                                                    
                                                    {/* <td>{row?.order_type ? capitalizeFirstLetter(row?.order_type) : 'N/A'}</td> */}
                                                    <td >
                                                        {new Date(row?.created_at).toLocaleString('en-GB', {
                                                            day: '2-digit',
                                                            month: '2-digit',
                                                            year: 'numeric',
                                                            hour: '2-digit',
                                                            minute: '2-digit',
                                                            hour12: true,
                                                        }).replace(',', '')}
                                                    </td>
                                                    <td>{row?.business_date ? formateDate(row?.business_date) : 'N/A' }</td>
                                                    <td className='text-end'>
                                                        <div className="dropdown  d-inline-block">
                                                            <button className="btn btn-icon btn-secondary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i className='ti ti-dots-vertical'></i>
                                                            </button>
                                                            <ul className="dropdown-menu">
                                                            {checkPermission('store_transaction', 'view') ?
                                                                <li><div className='dropdown-item' onClick={() => { viewFunction(row.id) }}><i className="ti ti-eye" aria-hidden="true"></i> View details</div></li>
                                                                :''}
                                                                <li>
                                                                    <div className='dropdown-item' onClick={() => printData(row, index)}>
                                                                        <i className="ti ti-printer" aria-hidden="true"></i> Print
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )) : <tr>
                                                <td colSpan={12} className="text-center">
                                                    <img src={notFound} style={{ width: "5%" }} alt="Not Found" />
                                                    <p>No records</p>
                                                </td>
                                            </tr>}
                                        </>}
                                </tbody>
                            </table>
                        </div>
                        <div className='tabler-footer'>
                            <div className='d-flex align-items-center'>
                                <div id="example1_info" role="status" className="table-result" aria-live="polite"><b>Total Records : {dataLength ? dataLength : "0"}</b></div>
                                {dataLength && dataLength > 0 ?
                                    <CustomPagination datalength={dataLength} itemperpage={itemPerPage} setPage={setPage} currentPage={page} pageRoute={[{ name: "customer", path: "/company/transaction/transaction/list" }]} /> : ""}
                            </div>
                        </div>
                    </div>
                    <div>
                    </div>
                </div>
            </div>
            <ToastContainer
                position="top-right"
                hideProgressBar={false}
                autoClose={true | 1000}
                newestOnTop={true}
                closeOnClick={false}
                draggable={false}
                rtl={false}
            />
        </>
    );
}

export default TransactionList